const SEPARATOR = ';'
const DEFAULT_PAGINATION_KEY = 'pagination_page'
export const DEFAULT_PAGE_SIZE = 30

let params = {}
class Query {
  constructor(route) {
    params = route?.query ?? {}
  }

  getSearchParams() {
    return params
  }

  getSearchParam(key) {
    return params[key] ?? null
  }

  getPaginationPage(paginationKey = DEFAULT_PAGINATION_KEY) {
    return +this.getSearchParam(paginationKey) || 1
  }

  setPaginationPage(page, paginationKey = DEFAULT_PAGINATION_KEY) {
    return this.setSearchParam(paginationKey, page, false)
  }

  setSearchParam(key, value, append = false) {
    if (append && params[key]) {
      params = { ...params, [key]: `${params[key]}${SEPARATOR}${value}` }
      return this
    }
    params = { ...params, [key]: value }
    return this
  }

  clearSearchParams() {
    params = {}
    return this
  }

  toV2Params() {
    const result = new URLSearchParams()
    for (const [key, rawValue] of Object.entries(params)) {
      const value = String(rawValue)
      if (key === DEFAULT_PAGINATION_KEY) {
        result.set('page', value)
      } else if (key === 'sort') {
        _applySortParam(result, value, params.direction)
      } else if (key === 'direction') {
        // owned by _applySortParam; skip to avoid double-write
      } else if (key === 'customer_rating') {
        // CustomerReviewAttribute stores a plain number; backend expects a range filter
        result.set('customer_rating[gte]', value)
        // exclude products whose hearts are hidden by MIN_RATING_COUNT (< 5 reviews)
        result.set('customer_rating_count[gte]', '5')
      } else if (value.includes(SEPARATOR)) {
        value.split(SEPARATOR).forEach((v) => result.append(`${key}[]`, v))
      } else {
        result.set(key, value)
      }
    }
    if (!result.has('page')) result.set('page', '1')
    if (!result.has('size')) result.set('size', String(DEFAULT_PAGE_SIZE))
    return result.toString()
  }

  removeSearchParam(key, toDelete = null) {
    const accessor = params[key] + ''
    if (!accessor) return this

    if (toDelete && accessor.split(SEPARATOR).length > 1) {
      params = { ...params, [key]: _sanitizeParam(accessor, toDelete) }
      return this
    }

    const { [key]: _, ...rest } = params
    params = rest
    return this
  }
}

const DEFAULT_DESC_SORTS = new Set(['customer_rating'])

const _applySortParam = (result, value, existingDirection) => {
  if (value === 'price_desc') {
    result.set('default_sort', 'price')
    result.set('direction', 'desc')
  } else {
    result.set('default_sort', value)
    result.set(
      'direction',
      existingDirection || (DEFAULT_DESC_SORTS.has(value) ? 'desc' : 'asc')
    )
    if (value === 'customer_rating') {
      // exclude products whose hearts are hidden by MIN_RATING_COUNT (< 5 reviews)
      result.set('customer_rating_count[gte]', '5')
    }
  }
}

/*
 * filters and combines attributes into a single string val1;val2
 * ('val1;val2;val3', 'val2') => 'val1;val3'
 */
const _sanitizeParam = (param, toDelete) => {
  const check = `${toDelete}`

  const values = param.split(SEPARATOR).filter((val) => val !== check)
  return values.join(SEPARATOR)
}

export default Query
